import { useEffect as s } from "react";
const c = (t) => {
  parent.window && parent.window.postMessage(t, "*");
}, d = (t, r) => {
  s(() => {
    let n;
    if (typeof t == "object" && "location" in t)
      n = parent;
    else if (t instanceof Object && "current" in t)
      n = t.current?.contentWindow;
    else
      return;
    if (n === null)
      return;
    const o = (e) => {
      if (n !== e.source || e.data?.type === void 0 || e.data?.type === "")
        return;
      const { type: i } = e.data;
      (typeof i == "string" || Object.prototype.toString.call(i) === "[object String]") && r(e.data);
    };
    return window.addEventListener("message", o), () => {
      window.removeEventListener("message", o);
    };
  }, [t, r]);
};
export {
  c as sendEvent,
  d as useSubscriber
};
